import React from "react";
import { Link } from "react-router-dom";
import { Wordmark } from "./Logo";
import { BRAND, NAV, CONTACT_EMAILS, BUSINESS_AREAS } from "../data/site";

const Footer = () => (
    <footer
        className="border-t border-[var(--ns-border)] bg-white"
        data-testid="site-footer"
    >
        <div className="max-w-[1280px] mx-auto px-6 lg:px-10 py-16">
            <div className="grid lg:grid-cols-12 gap-10">
                <div className="lg:col-span-4">
                    <Wordmark />
                    <p
                        className="mt-6 font-body text-sm leading-relaxed max-w-sm"
                        style={{ color: "var(--ns-muted)" }}
                    >
                        {BRAND.description}
                    </p>
                </div>

                <div className="lg:col-span-3">
                    <div
                        className="font-body text-[11px] uppercase tracking-[0.22em] mb-5"
                        style={{ color: "var(--ns-muted-2)" }}
                    >
                        Navigation
                    </div>
                    <ul className="space-y-3">
                        {NAV.map((n) => (
                            <li key={n.to}>
                                <Link
                                    to={n.to}
                                    className="font-body text-sm hover:text-[var(--ns-ink)] transition-colors"
                                    style={{ color: "var(--ns-body)" }}
                                >
                                    {n.label}
                                </Link>
                            </li>
                        ))}
                        <li>
                            <Link
                                to="/contact"
                                className="font-body text-sm hover:text-[var(--ns-ink)] transition-colors"
                                style={{ color: "var(--ns-body)" }}
                            >
                                Contact
                            </Link>
                        </li>
                    </ul>
                </div>

                <div className="lg:col-span-3">
                    <div
                        className="font-body text-[11px] uppercase tracking-[0.22em] mb-5"
                        style={{ color: "var(--ns-muted-2)" }}
                    >
                        Business Areas
                    </div>
                    <ul className="space-y-3">
                        {BUSINESS_AREAS.map((b) => (
                            <li key={b.slug}>
                                <Link
                                    to={`/business-areas/${b.slug}`}
                                    className="font-body text-sm hover:text-[var(--ns-ink)] transition-colors"
                                    style={{ color: "var(--ns-body)" }}
                                >
                                    {b.title}
                                </Link>
                            </li>
                        ))}
                    </ul>
                </div>

                <div className="lg:col-span-2">
                    <div
                        className="font-body text-[11px] uppercase tracking-[0.22em] mb-5"
                        style={{ color: "var(--ns-muted-2)" }}
                    >
                        Enquiries
                    </div>
                    <ul className="space-y-3">
                        {CONTACT_EMAILS.map((e) => (
                            <li key={e}>
                                <a
                                    href={`mailto:${e}`}
                                    className="font-body text-sm hover:text-[var(--ns-ink)] transition-colors break-all"
                                    style={{ color: "var(--ns-body)" }}
                                    data-testid={`footer-email-${e}`}
                                >
                                    {e}
                                </a>
                            </li>
                        ))}
                    </ul>
                </div>
            </div>

            <div className="mt-14 pt-8 border-t border-[var(--ns-border)] flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4">
                <div
                    className="font-body text-[11px] uppercase tracking-[0.22em]"
                    style={{ color: "var(--ns-muted)" }}
                >
                    © {new Date().getFullYear()} {BRAND.legal} — All rights reserved
                </div>
                <div
                    className="font-body text-[11px] uppercase tracking-[0.22em]"
                    style={{ color: "var(--ns-muted)" }}
                >
                    General Trading · Strategic Sourcing
                </div>
            </div>
        </div>
    </footer>
);

export default Footer;
